import { Search } from "@tamagui/lucide-icons"; // or use `lucide-react-native` directly
import { Input, XStack } from "tamagui";

export const SearchBox = ({ value, onChangeText, onSubmit }) => (
  <XStack
    alignItems="center"
    borderRadius="$4"
    borderColor={"$gray3"}
    borderWidth={1}
    paddingHorizontal="$3"
    backgroundColor="$gray1"
    width="100%"
    maxWidth={400}
  >
    <Input
      placeholder="Search Customer..."
      placeholderTextColor="$gray12"
      color="$gray12"
      flex={1}
      unstyled
      fontSize="$4"
      paddingVertical="$2"
      focusStyle={{ borderWidth: 0, outlineWidth: 0 }}
      value={value}
      onChangeText={onChangeText}
      onSubmitEditing={onSubmit}
    />
    <Search size={18} color="$gray12" />
  </XStack>
);

export default SearchBox;
